<template>
  <div class="ProductKeywordAnalyze">
    <div class="header-box">
      <div class="header-line"></div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="getProductKeyword">查询</el-button>
        <el-button type="primary" size="small" @click="onAddProductBtnClick">新增竞品</el-button>
        <!-- <el-button type="primary" size="small"> -->
        <!-- <download-excel :data="productData" :fields="productTitles" :name="getExportProductName()">导出商品</download-excel> -->
        <!-- </el-button> -->
      </div>
    </div>
    <div class="title-text">商品信息：</div>
    <div class="product-box" ref="productInfo">
      <div class="product-info">
        <span class="product-info-text">产品名称：</span>
        <span>{{ productInfo.productName }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">标题：</span>
        <span v-html="productTitle"></span>
      </div>
      <div class="product-info"><span class="product-info-text">五点描述1：</span><span v-html="fivePoint1"></span></div>
      <div class="product-info"><span class="product-info-text">五点描述2：</span><span v-html="fivePoint2"></span></div>
      <div class="product-info"><span class="product-info-text">五点描述3：</span><span v-html="fivePoint3"></span></div>
      <div class="product-info"><span class="product-info-text">五点描述4：</span><span v-html="fivePoint4"></span></div>
      <div class="product-info"><span class="product-info-text">五点描述5：</span><span v-html="fivePoint5"></span></div>
      <div class="product-info"><span class="product-info-text">搜索词：</span><span v-html="searchTerms"></span></div>
    </div>
    <div class="title-text">已选关键词单词统计：</div>
    <div class="product-box"><span v-html="analyzeWordsHtml"></span></div>
    <div class="title-text">已选关键词信息：</div>
    <div class="product-box"><span v-html="selectedKeywordsHtml"></span></div>
    <div class="title-text">词频统计：</div>
    <div class="word-analyze-box">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="竞品标题" name="competitorTitle"></el-tab-pane>
        <el-tab-pane label="竞品五点描述" name="competitorFivePoint"></el-tab-pane>
        <el-tab-pane label="竞品评论" name="competitorReview"></el-tab-pane>
        <el-tab-pane label="产品成交词" name="productDealWord"></el-tab-pane>
        <el-tab-pane label="成交词分析" name="dealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="90日成交词模型分析" name="modelDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="30日成交词模型分析" name="model30DayDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="7成交词模型分析" name="model7DayDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="90日长尾词模型分析" name="phoneModelDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="30日长尾词模型分析" name="phone30DayModelDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="7日长尾词模型分析" name="phone7DayModelDealWordAnalyze"></el-tab-pane>
        <el-tab-pane label="商品推广搜索词" name="searchWordAnalyze"></el-tab-pane>
        <el-tab-pane label="非核心成交词分析" name="productDealExcludeCoreWord"></el-tab-pane>
        <el-tab-pane label="SKU成交词" name="skuDealWord"></el-tab-pane>
        <el-tab-pane label="搜索排名" name="searchRankWord"></el-tab-pane>
        <el-tab-pane label="热门搜索词" name="hotSearchWord"></el-tab-pane>
      </el-tabs>
      <div class="main-box" :height="screenHeight">
        <el-table :data="oneWordList" border size="small" @select="handleSelectionChange" :class="{ 'one-word-normal-table': activeName == 'competitorTitle' || activeName == 'competitorFivePoint' || activeName == 'competitorReview' || activeName == 'productDealWord' || activeName == 'searchRankWord' || activeName == 'hotSearchWord', 'one-word-analyze-table': activeName == 'dealWordAnalyze' }" show-summary>
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column width="55" :key="1000">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="checkStatus" label="单词" width="30px"> </el-table-column> -->
          <el-table-column prop="keyword" label="单词" width="220px" :key="1001"> </el-table-column>
          <el-table-column prop="times" label="频次" width="50px" align="right" :key="1002"> </el-table-column>

          <template v-if="activeName == 'dealWordAnalyze' || activeName == 'productDealExcludeCoreWord' || activeName == 'modelDealWordAnalyze' || activeName == 'phoneModelDealWordAnalyze'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="80px" align="right" sortable :key="1003"> </el-table-column>
            <el-table-column prop="last90DayClicks" label="90日点击" width="80px" align="right" sortable :key="1004"> </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="80px" align="right" sortable :key="1005"> </el-table-column>
            <el-table-column prop="last90DayUnits" label="90日商品" width="80px" align="right" sortable :key="1006"> </el-table-column>
            <el-table-column prop="last90DayClickRate" label="90日点击率" width="90px" align="right" sortable :key="1007">
              <template slot-scope="scope">
                {{ scope.row["last90DayClickRate"] && (scope.row["last90DayClickRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="90px" align="right" sortable :key="1008">
              <template slot-scope="scope">
                {{ scope.row["last90DayConversionRate"] && (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DaySpend" label="90日花费" width="80px" align="right" sortable :key="1009">
              <template slot-scope="scope">
                {{ scope.row["last90DaySpend"] && scope.row["last90DaySpend"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DaySales" label="90日销售" width="80px" align="right" sortable :key="1010">
              <template slot-scope="scope">
                {{ scope.row["last90DaySales"] && scope.row["last90DaySales"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayCPC" label="90日CPC" width="80px" align="right" sortable :key="10011">
              <template slot-scope="scope">
                {{ scope.row["last90DayCPC"] && scope.row["last90DayCPC"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayACOS" label="90日ACOS" width="90px" align="right" sortable :key="1012">
              <template slot-scope="scope">
                {{ scope.row["last90DayACOS"] && scope.row["last90DayACOS"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayROAS" label="90日ROAS" width="90px" align="right" sortable :key="1013">
              <template slot-scope="scope">
                {{ scope.row["last90DayROAS"] && scope.row["last90DayROAS"].toFixed(2) }}
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName == 'phone30DayModelDealWordAnalyze' || activeName == 'model30DayDealWordAnalyze'">
            <el-table-column prop="last30DayImpressions" label="30日展现" width="80px" align="right" sortable :key="1014"> </el-table-column>
            <el-table-column prop="last30DayClicks" label="30日点击" width="80px" align="right" sortable :key="1015"> </el-table-column>
            <el-table-column prop="last30DayOrders" label="30日订单" width="80px" align="right" sortable :key="1016"> </el-table-column>
            <el-table-column prop="last30DayUnits" label="30日商品" width="80px" align="right" sortable :key="1017"> </el-table-column>
            <el-table-column prop="last30DayClickRate" label="30日点击率" width="90px" align="right" sortable :key="1018">
              <template slot-scope="scope">
                {{ scope.row["last30DayClickRate"] && (scope.row["last30DayClickRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DayConversionRate" label="30日转化率" width="90px" align="right" sortable :key="1019">
              <template slot-scope="scope">
                {{ scope.row["last30DayConversionRate"] && (scope.row["last30DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DaySpend" label="30日花费" width="80px" align="right" sortable :key="1020">
              <template slot-scope="scope">
                {{ scope.row["last30DaySpend"] && scope.row["last30DaySpend"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DaySales" label="30日销售" width="80px" align="right" sortable :key="1021">
              <template slot-scope="scope">
                {{ scope.row["last30DaySales"] && scope.row["last30DaySales"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DayCPC" label="30日CPC" width="80px" align="right" sortable :key="1022">
              <template slot-scope="scope">
                {{ scope.row["last30DayCPC"] && scope.row["last30DayCPC"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DayACOS" label="30日ACOS" width="90px" align="right" sortable :key="1023">
              <template slot-scope="scope">
                {{ scope.row["last30DayACOS"] && scope.row["last30DayACOS"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last30DayROAS" label="30日ROAS" width="90px" align="right" sortable :key="1024">
              <template slot-scope="scope">
                {{ scope.row["last30DayROAS"] && scope.row["last30DayROAS"].toFixed(2) }}
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName == 'phone7DayModelDealWordAnalyze' || activeName == 'model7DayDealWordAnalyze'">
            <el-table-column prop="last7DayImpressions" label="7日展现" width="80px" align="right" sortable :key="1025"> </el-table-column>
            <el-table-column prop="last7DayClicks" label="7日点击" width="80px" align="right" sortable :key="1026"> </el-table-column>
            <el-table-column prop="last7DayOrders" label="7日订单" width="80px" align="right" sortable :key="1027"> </el-table-column>
            <el-table-column prop="last7DayUnits" label="7日商品" width="80px" align="right" sortable :key="1028"> </el-table-column>
            <el-table-column prop="last7DayClickRate" label="7日点击率" width="90px" align="right" sortable :key="1029">
              <template slot-scope="scope">
                {{ scope.row["last7DayClickRate"] && (scope.row["last7DayClickRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DayConversionRate" label="7日转化率" width="90px" align="right" sortable :key="1030">
              <template slot-scope="scope">
                {{ scope.row["last7DayConversionRate"] && (scope.row["last7DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DaySpend" label="7日花费" width="80px" align="right" sortable :key="1031">
              <template slot-scope="scope">
                {{ scope.row["last7DaySpend"] && scope.row["last7DaySpend"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DaySales" label="7日销售" width="80px" align="right" sortable :key="1032">
              <template slot-scope="scope">
                {{ scope.row["last7DaySales"] && scope.row["last7DaySales"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DayCPC" label="7日CPC" width="80px" align="right" sortable :key="1033">
              <template slot-scope="scope">
                {{ scope.row["last7DayCPC"] && scope.row["last7DayCPC"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DayACOS" label="7日ACOS" width="90px" align="right" sortable :key="1034">
              <template slot-scope="scope">
                {{ scope.row["last7DayACOS"] && scope.row["last7DayACOS"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="last7DayROAS" label="7日ROAS" width="90px" align="right" sortable :key="1035">
              <template slot-scope="scope">
                {{ scope.row["last7DayROAS"] && scope.row["last7DayROAS"].toFixed(2) }}
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName == 'productDealWord'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="70px" align="right" sortable :key="1036"> </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="70px" align="right" sortable :key="1037">
              <template slot-scope="scope">
                {{ scope.row["last90DayConversionRate"] && (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="50px" align="right" sortable :key="1038"> </el-table-column>
          </template>

          <template v-if="activeName == 'searchWordAnalyze'">
            <el-table-column prop="impressions" label="展现" width="80px" align="right" sortable :key="1025"> </el-table-column>
            <el-table-column prop="clicks" label="点击" width="80px" align="right" sortable :key="1026"> </el-table-column>
            <el-table-column prop="orders" label="订单" width="80px" align="right" sortable :key="1027"> </el-table-column>
            <el-table-column prop="units" label="商品" width="80px" align="right" sortable :key="1028"> </el-table-column>
            <el-table-column prop="clickRate" label="点击率" width="90px" align="right" sortable :key="1029">
              <template slot-scope="scope">
                {{ scope.row["clickRate"] && (scope.row["clickRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="conversionRate" label="转化率" width="90px" align="right" sortable :key="1030">
              <template slot-scope="scope">
                {{ scope.row["conversionRate"] && (scope.row["conversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="spend" label="花费" width="80px" align="right" sortable :key="1031">
              <template slot-scope="scope">
                {{ scope.row["spend"] && scope.row["spend"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="sales" label="销售" width="80px" align="right" sortable :key="1032">
              <template slot-scope="scope">
                {{ scope.row["sales"] && scope.row["sales"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="cpc" label="CPC" width="80px" align="right" sortable :key="1033">
              <template slot-scope="scope">
                {{ scope.row["cpc"] && scope.row["cpc"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="acos" label="ACOS" width="90px" align="right" sortable :key="1034">
              <template slot-scope="scope">
                {{ scope.row["acos"] && scope.row["acos"].toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="roas" label="ROAS" width="90px" align="right" sortable :key="1035">
              <template slot-scope="scope">
                {{ scope.row["roas"] && scope.row["roas"].toFixed(2) }}
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-table v-if="activeName == 'competitorTitle' || activeName == 'competitorFivePoint' || activeName == 'competitorReview' || activeName == 'productDealWord' || activeName == 'searchRankWord' || activeName == 'hotSearchWord'" :data="twoWordList" border size="small" @select="handleSelectionChange" style="width: 450px; display: inline-block; vertical-align: top">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="keyword" label="2词词组" width="120px"> </el-table-column>
          <el-table-column prop="times" label="频次" width="60px" align="right"> </el-table-column>
          <template v-if="activeName == 'productDealWord'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="70px" align="right" sortable> </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="70px" align="right" sortable>
              <template slot-scope="scope">
                {{ (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="50px" align="right" sortable> </el-table-column>
          </template>
        </el-table>
        <el-table v-if="activeName == 'competitorTitle' || activeName == 'competitorFivePoint' || activeName == 'competitorReview' || activeName == 'productDealWord' || activeName == 'searchRankWord' || activeName == 'hotSearchWord'" :data="threeWordList" border size="small" @select="handleSelectionChange" style="width: 500px; display: inline-block; vertical-align: top">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="keyword" label="3词词组" width="150px"> </el-table-column>
          <el-table-column prop="times" label="频次" width="70px" align="right"> </el-table-column>
          <template v-if="activeName == 'productDealWord'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="70px" align="right" sortable> </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="70px" align="right" sortable>
              <template slot-scope="scope">
                {{ (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="50px" align="right" sortable> </el-table-column>
          </template>
        </el-table>
        <el-table v-if="activeName == 'competitorTitle' || activeName == 'competitorFivePoint' || activeName == 'competitorReview' || activeName == 'productDealWord' || activeName == 'searchRankWord' || activeName == 'hotSearchWord'" :data="fourWordList" border size="small" @select="handleSelectionChange" style="width: 550px; display: inline-block; vertical-align: top">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="keyword" label="4词词组" width="200px"> </el-table-column>
          <el-table-column prop="times" label="频次" width="70px" align="right"> </el-table-column>
          <template v-if="activeName == 'productDealWord'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="70px" align="right" sortable> </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="70px" align="right" sortable>
              <template slot-scope="scope">
                {{ (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="50px" align="right" sortable> </el-table-column>
          </template>
        </el-table>
        <el-table v-if="activeName == 'competitorTitle' || activeName == 'competitorFivePoint' || activeName == 'competitorReview' || activeName == 'productDealWord' || activeName == 'searchRankWord' || activeName == 'hotSearchWord'" :data="fiveWordList" border size="small" @select="handleSelectionChange" style="width: 600px; display: inline-block; vertical-align: top">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="keyword" label="5词词组" width="220px"> </el-table-column>
          <el-table-column prop="times" label="频次" width="70px" align="right"> </el-table-column>
          <template v-if="activeName == 'productDealWord'">
            <el-table-column prop="last90DayImpressions" label="90日展现" width="70px" align="right" sortable> </el-table-column>
            <el-table-column prop="last90DayConversionRate" label="90日转化率" width="70px" align="right" sortable>
              <template slot-scope="scope">
                {{ (scope.row["last90DayConversionRate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="last90DayOrders" label="90日订单" width="50px" align="right" sortable> </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <el-dialog title="新增竞品" :visible.sync="parentProductDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称1</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle1" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述1</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint1" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论1</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview1" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称2</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述2</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论2</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称3</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle3" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述3</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint3" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论3</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview3" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称4</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle4" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述4</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint4" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论4</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview4" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称5</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle5" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述5</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint5" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论5</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview5" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称6</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle6" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述6</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint6" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论6</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview6" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称7</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle7" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述7</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint7" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论7</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview7" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称8</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle8" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述8</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint8" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论8</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview8" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称9</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle9" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述9</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint9" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论9</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview9" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品名称10</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorTitle10" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品五点描述10</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorFivePoint10" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>竞品评论10</span>
        <el-input class="form-input" placeholder="请输入" v-model="competitorInfo.competitorReview10" size="small" clearable> </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="parentProductDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      productType: this.$route.query.productType,
      sku: this.$route.query.sku,
      isIndeterminate: true,
      parentProductDialogVisible: false,
      activeName: "competitorTitle",
      sourceType: "competitorTitle",
      selectedKeywords: new Set([]),
      selectedKeywordsMap: new Map(),
      selectedKeywordsText: "",
      selectedKeywordsList: [],
      selectedAnalyzeWords: [],
      productInfo: {},
      wordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      competitorTitleWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      competitorFivePointWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      competitorReviewWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      skuDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      productDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      searchRankWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      hotSearchWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      excludeCoreDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      modelDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      model30DayDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      model7DayDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      phoneModelDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      phone30DayModelDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      phone7DayModelDealWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      searchWordAnalyzeWordsList: {
        oneWordList: [],
        twoWordList: [],
        threeWordList: [],
        fourWordList: [],
        fiveWordList: [],
      },
      competitorInfo: {
        competitorTitle1: "",
        competitorFivePoint1: "",
        competitorReview1: "",
        competitorTitle2: "",
        competitorFivePoint2: "",
        competitorReview2: "",
        competitorTitle3: "",
        competitorFivePoint3: "",
        competitorReview3: "",
        competitorTitle4: "",
        competitorFivePoint4: "",
        competitorReview4: "",
        competitorTitle5: "",
        competitorFivePoint5: "",
        competitorReview5: "",
        competitorTitle6: "",
        competitorFivePoint6: "",
        competitorReview6: "",
        competitorTitle7: "",
        competitorFivePoint7: "",
        competitorReview7: "",
        competitorTitle8: "",
        competitorFivePoint8: "",
        competitorReview8: "",
        competitorTitle9: "",
        competitorFivePoint9: "",
        competitorReview9: "",
        competitorTitle10: "",
        competitorFivePoint10: "",
        competitorReview10: "",
      },
    };
  },
  mounted() {
    this.getAllProducts();
    this.getProductKeyword();
    this.getProductKeywordAnalyze("competitorTitle");

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
      console.log("calculateHeight", this.screenHeight);
    },
    getColorfulHtml(text) {
      if (!text) return;
      let tokens = text.toLowerCase().split(" ");
      let html = "";
      tokens.forEach(token => {
        let word = token;
        word = word.replace(",", "");
        word = word.replace("(", "");
        word = word.replace(")", "");
        if (token.indexOf(",") != -1 || token.indexOf("(") != -1 || (token.indexOf(")") != -1 && this.selectedAnalyzeWords.length > 0)) {
          console.log("11");
        }
        if (this.selectedAnalyzeWords.includes(word)) {
          html += `<span class="red">${token}</span> `;
        } else {
          html += token + " ";
        }
      });
      return html;
    },
    getKeywordColorfulHtml(text) {
      if (!text || !this.productInfo) return;

      let productText = (this.productInfo.title + " " + this.productInfo.des1 + " " + this.productInfo.des2 + " " + this.productInfo.des3 + " " + this.productInfo.des4 + " " + this.productInfo.des5).toLowerCase();

      let tokens = text.toLowerCase().split(",");
      let html = "";
      tokens.forEach(token => {
        if (productText.indexOf(token) != -1) {
          html += `<span class="red">${token}</span>, `;
        } else {
          html += token + ",";
        }
      });
      return html;
    },
    handleSelectionChange(selecteds, row) {
      let isSelected = false;
      // selecteds.forEach(data => data.keyword == row.keyword && (isSelected = true));
      // if (isSelected) {
      //   this.selectedKeywords.add(row);
      // } else {
      //   this.selectedKeywords.delete(row);
      // }
      // let keywordsList = [...this.selectedKeywords];
      // keywordsList.sort((a, b) => b.times - a.times);
      // this.selectedKeywordsText = "";
      // keywordsList.forEach(word => this.selectedKeywordsList.push(word.keyword + ", "));
      // this.selectedKeywordsText = this.selectedKeywordsList.join(", ");

      // this.updateProductKeyword();
    },
    handleChange(row) {
      row.checkStatus == 1 && this.selectedKeywordsMap.set(row.keyword, { ...row });
      row.checkStatus == 0 && this.selectedKeywordsMap.delete(row.keyword);

      let values = [...this.selectedKeywordsMap.values()];
      values.sort((a, b) => b.times - a.times);

      this.selectedKeywordsList = [];
      values.forEach(word => this.selectedKeywordsList.push(word.keyword));
      this.selectedKeywordsText = this.selectedKeywordsList.join(",");

      this.updateProductKeyword();
    },
    updateProductKeyword() {
      let values = [...this.selectedKeywordsMap.values()];
      let params = {
        productType: this.productType,
        sku: this.sku ? this.sku : "",
        keywords: this.selectedKeywordsText,
        checkedWords: JSON.stringify(values),
      };
      requestModules.updateProductKeyword(params).then(res => {
        this.getProductKeyword();
      });
    },
    getAllProducts() {
      requestModules.fetchParentProducts({ productType: this.productType }).then(res => {
        this.productInfo = res.ldata[0];
      });
    },
    getProductKeyword() {
      let params = { productType: this.productType };
      this.sku && (params.sku = this.sku);
      requestModules
        .fetchProductKeyword(params)
        .then(res => {
          if (res.mdata.productWordInfo) {
            res.mdata.productWordInfo.words && (this.selectedAnalyzeWords = JSON.parse(res.mdata.productWordInfo.words));

            if (res.mdata.productWordInfo.checkedWords) {
              let checkedWords = JSON.parse(res.mdata.productWordInfo.checkedWords);
              checkedWords.forEach(word => this.selectedKeywordsMap.set(word.keyword, word));

              checkedWords.sort((a, b) => b.times - a.times);
              this.selectedKeywordsList = [];
              checkedWords.forEach(word => this.selectedKeywordsList.push(word.keyword));
              this.selectedKeywordsText = this.selectedKeywordsList.join(", ");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });

      this.getProductKeywordAnalyze(this.activeName);
    },
    getProductKeywordAnalyze(sourceType) {
      let productType = this.productType;
      if (this.activeName == "hotSearchWord") {
        productType = 10000;
      }

      let params = { productType, sourceType };
      if (this.activeName == "skuDealWord") {
        params.sku = this.sku;
      } else if (this.activeName == "dealWordAnalyze") {
        params.sourceType = "productDealWord";
      }
      requestModules.getProductKeywordAnalyze(params).then(res => {
        if (sourceType == "competitorTitle") {
          this.competitorTitleWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "competitorFivePoint") {
          this.competitorFivePointWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "competitorReview") {
          this.competitorReviewWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "productDealWord" || sourceType == "dealWordAnalyze") {
          this.productDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "skuDealWord") {
          this.skuDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "searchRankWord") {
          this.searchRankWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "hotSearchWord") {
          this.hotSearchWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "productDealExcludeCoreWord") {
          this.excludeCoreDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "modelDealWordAnalyze") {
          this.modelDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "model30DayDealWordAnalyze") {
          this.model30DayDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "model7DayDealWordAnalyze") {
          this.model7DayDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "phoneModelDealWordAnalyze") {
          this.phoneModelDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "phone30DayModelDealWordAnalyze") {
          this.phone30DayModelDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "phone7DayModelDealWordAnalyze") {
          this.phone7DayModelDealWordsList = res.mdata.wordsInfo;
        } else if (sourceType == "searchWordAnalyze") {
          this.searchWordAnalyzeWordsList = res.mdata.wordsInfo;
        }

        this.wordsList = res.mdata.wordsInfo;
        this.campetitorInfo = res.mdata.campetitorInfo ? res.mdata.campetitorInfo : {};
      });
    },
    onAddProductBtnClick() {
      this.parentProductDialogVisible = true;
    },
    childProduct(row) {
      window.open("/client/parentProductMgmt/childProductMgmt?productType=" + row.productType);
    },
    handleClick(tab, event) {
      let name = tab.name;
      this.sourceType = name;

      if (name == "competitorTitle" && this.competitorTitleWordsList.length > 0) {
        this.wordsList = this.competitorTitleWordsList;
      } else if (name == "competitorFivePoint" && this.competitorFivePointWordsList.length > 0) {
        this.wordsList = this.competitorFivePointWordsList;
      } else if (name == "competitorReview" && this.competitorReviewWordsList.length > 0) {
        this.wordsList = this.competitorReviewWordsList;
      } else if ((name == "productDealWord" || name == "dealWordAnalyze") && this.productDealWordsList.length > 0) {
        this.wordsList = this.productDealWordsList;
      } else if (name == "skuDealWord" && this.skuDealWordsList.length > 0) {
        this.wordsList = this.skuDealWordsList;
      } else if (name == "searchRankWord" && this.searchRankWordsList.length > 0) {
        this.wordsList = this.searchRankWordsList;
      } else if (name == "hotSearchWord" && this.hotSearchWordsList.length > 0) {
        this.wordsList = this.hotSearchWordsList;
      } else if (name == "productDealExcludeCoreWord" && this.excludeCoreDealWordsList.length > 0) {
        this.wordsList = this.excludeCoreDealWordsList;
      } else if (name == "modelDealWordAnalyze" && this.modelDealWordsList.length > 0) {
        this.wordsList = this.modelDealWordsList;
      } else if (name == "model30DayDealWordAnalyze" && this.model30DayDealWordsList.length > 0) {
        this.wordsList = this.model30DayDealWordsList;
      } else if (name == "model7DayDealWordAnalyze" && this.model7DayDealWordsList.length > 0) {
        this.wordsList = this.model7DayDealWordsList;
      } else if (name == "phoneModelDealWordAnalyze" && this.phoneModelDealWordsList.length > 0) {
        this.wordsList = this.phoneModelDealWordsList;
      } else if (name == "phone30DayModelDealWordAnalyze" && this.phone30DayModelDealWordsList.length > 0) {
        this.wordsList = this.phone30DayModelDealWordsList;
      } else if (name == "phone7DayModelDealWordAnalyze" && this.phone7DayModelDealWordsList.length > 0) {
        this.wordsList = this.phone7DayModelDealWordsList;
      } else if (name == "searchWordAnalyze") {
        if (this.searchWordAnalyzeWordsList.length > 0) {
          this.wordsList = this.searchWordAnalyzeWordsList;
        } else {
          this.getSearchWordAnalyzeWords();
        }
      } else {
        this.getProductKeywordAnalyze(this.sourceType);
      }
    },
    getSearchWordAnalyzeWords() {
      requestModules.getSearchWordAnalyzeWords({ productType: this.productType }).then(res => {
        this.searchWordAnalyzeWordsList = res.mdata;

        this.wordsList = res.mdata;
        this.campetitorInfo = res.mdata.campetitorInfo ? res.mdata.campetitorInfo : {};
      });
    },
    handleConfirmBtn() {
      requestModules
        .updateProductKeywordInfo({
          productType: this.productType,
          campetitorInfo: JSON.stringify(this.competitorInfo),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getProductKeywordAnalyze();
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  computed: {
    oneWordList() {
      let list = [];
      this.wordsList.oneWordList.forEach(word =>
        list.push({
          ...word,
          checkStatus: this.selectedKeywordsList.includes(word.keyword) ? 1 : 0,
        })
      );
      if (this.sourceType == "modelDealWordAnalyze" || this.sourceType == "phoneModelDealWordAnalyze") {
        list.sort((a, b) => b.last90DaySpend - a.last90DaySpend);
      } else if (this.sourceType == "phone30DayModelDealWordAnalyze" || this.sourceType == "model30DayDealWordAnalyze") {
        list.sort((a, b) => b.last30DaySpend - a.last30DaySpend);
      } else if (this.sourceType == "phone7DayModelDealWordAnalyze" || this.sourceType == "model7DayDealWordAnalyze") {
        list.sort((a, b) => b.last7DaySpend - a.last7DaySpend);
      }
      return list;
    },
    twoWordList() {
      let list = [];
      this.wordsList.twoWordList.forEach(word =>
        list.push({
          ...word,
          checkStatus: this.selectedKeywordsList.includes(word.keyword) ? 1 : 0,
        })
      );
      return list;
    },
    threeWordList() {
      let list = [];
      this.wordsList.threeWordList.forEach(word =>
        list.push({
          ...word,
          checkStatus: this.selectedKeywordsList.includes(word.keyword) ? 1 : 0,
        })
      );
      return list;
    },
    fourWordList() {
      let list = [];
      this.wordsList.fourWordList.forEach(word =>
        list.push({
          ...word,
          checkStatus: this.selectedKeywordsList.includes(word.keyword) ? 1 : 0,
        })
      );
      return list;
    },
    fiveWordList() {
      let list = [];
      this.wordsList.fiveWordList.forEach(word =>
        list.push({
          ...word,
          checkStatus: this.selectedKeywordsList.includes(word.keyword) ? 1 : 0,
        })
      );
      return list;
    },
    productTitle() {
      return this.getColorfulHtml(this.productInfo.title);
    },
    fivePoint1() {
      return this.getColorfulHtml(this.productInfo.des1);
    },
    fivePoint2() {
      return this.getColorfulHtml(this.productInfo.des2);
    },
    fivePoint3() {
      return this.getColorfulHtml(this.productInfo.des3);
    },
    fivePoint4() {
      return this.getColorfulHtml(this.productInfo.des4);
    },
    fivePoint5() {
      return this.getColorfulHtml(this.productInfo.des5);
    },
    searchTerms() {
      return this.getColorfulHtml(this.productInfo.searchTerms);
    },
    analyzeWordsHtml() {
      return this.getKeywordColorfulHtml(this.selectedAnalyzeWords.join(","));
    },
    selectedKeywordsHtml() {
      return this.getKeywordColorfulHtml(this.selectedKeywordsText);
    },
  },
};
</script>

<style lang="scss">
.ProductKeywordAnalyze {
  .title-text {
    font-size: 18px;
    font-weight: bold;
    margin: 10px 0 5px 0;
  }

  .one-word-normal-table {
    width: 400px;
    display: inline-block;
    vertical-align: top;
  }

  .one-word-analyze-table {
    width: 1245px;
    display: inline-block;
    vertical-align: top;
  }

  .product-box {
    padding: 10px;
    margin: 10px 0px;
    background-color: white;

    .red {
      color: red;
    }

    .product-info {
      .product-info-text {
        display: inline-block;
        width: 100px;
        text-align: right;
        font-weight: bold;
      }
    }
  }
  .word-analyze-box {
    background-color: white;
    padding: 10px;
  }
  .no-padding {
    padding: 0px !important;
    .cell {
      padding: 0px !important;
    }
  }
  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 80px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
      .el-radio {
        width: 70px;
      }
    }
  }

  .redBg {
    background-color: red;
    color: white;
  }
  .yellowBg {
    background-color: yellow;
  }
  .greenBg {
    background-color: green;
    color: white;
  }
  .redText {
    color: red;
  }
  .greenText {
    color: green;
  }
}
</style>
